// extracted by mini-css-extract-plugin
module.exports = {"modal":"TriagePopup_modal__2h9Qq","container":"TriagePopup_container__1WYUM"};